var _defs, _g, _path, _path2, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g3, _path12;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHotel = function SvgHotel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 28
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "hotel_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Subtraction 9",
    d: "M938 4599h-18v-25h18v9.206a5.5 5.5 0 0 0 0 10.586v5.206Z",
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Mask Group 111",
    clipPath: "url(#hotel_svg__a)",
    transform: "translate(-916.5 -4571.5)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 2390",
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M920 4574h18v25h-18z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921 4575h16v23h-16z"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 329",
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M1 27h27"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 330",
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M9 24h7"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Rectangle 2391",
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "none",
    d: "M9.5 17.5h6v7h-6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 18.5h4v5h-4z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 331",
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 10V7"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 332",
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.25 7H8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 339",
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M8 16v-3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 340",
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M10.25 13H8"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 337",
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15.375 10V7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 338",
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17.625 7h-2.25"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 343",
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M15.375 16v-3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 344",
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M17.625 13h-2.25"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 345",
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M23 26v-4"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    "data-name": "Ellipse 477",
    transform: "translate(17.5 11.5)",
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.5,
    cy: 5.5,
    r: 4.5
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    "data-name": "Line 346",
    fill: "none",
    stroke: "#102b3f",
    strokeLinecap: "round",
    strokeWidth: 2,
    d: "M8 1h9"
  })));
};

export default SvgHotel;